import {
  AnyApiFactory,
  analyticsApiRef,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  githubAuthApiRef,
  gitlabAuthApiRef,
  identityApiRef,
  microsoftAuthApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import {
  ScmAuth,
  ScmIntegrationsApi,
  scmAuthApiRef,
  scmIntegrationsApiRef,
} from '@backstage/integration-react';
import { VisitsStorageApi, visitsApiRef } from '@backstage/plugin-home';
import { signalApiRef } from '@backstage/plugin-signals-react';
import { UserSettingsStorage } from '@backstage/plugin-user-settings';

import { AzureApplicationInsights } from './analytics/AzureApplicationInsights';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: scmAuthApiRef,
    deps: {
      githubAuthApi: githubAuthApiRef,
      gitlabAuthApi: gitlabAuthApiRef,
      microsoftAuthApi: microsoftAuthApiRef,
    },
    factory: ({ githubAuthApi, gitlabAuthApi, microsoftAuthApi }) =>
      ScmAuth.merge(
        ScmAuth.forGithub(githubAuthApi),
        ScmAuth.forGitlab(gitlabAuthApi),
        ScmAuth.forAzure(microsoftAuthApi),
      ),
  }),
  createApiFactory({
    api: storageApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      errorApi: errorApiRef,
      fetchApi: fetchApiRef,
      identityApi: identityApiRef,
      signalApi: signalApiRef,
    },
    factory: deps => UserSettingsStorage.create(deps),
  }),
  createApiFactory({
    api: visitsApiRef,
    deps: {
      identityApi: identityApiRef,
      storageApi: storageApiRef,
    },
    factory: deps => VisitsStorageApi.create(deps),
  }),
  createApiFactory({
    api: analyticsApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ configApi, identityApi }) =>
      AzureApplicationInsights.fromConfig(configApi, { identityApi }),
  }),
];
